(() => {
  const rewardCode = 'UMFRAGE35';
  const rewardParam = 'survey_reward';
  const expiryParam = 'survey_reward_expires';
  const storageKey = 'mm_survey_reward_v1';
  const legacySessionKey = 'mm_survey_reward_code';
  const lifetimeMs = 24 * 60 * 60 * 1000;
  const campaignEndsAt = Date.parse('2026-12-31T23:59:59+01:00');
  const now = Date.now();

  function storage(kind, action, key, value) {
    try {
      if (action === 'get') return window[kind].getItem(key);
      if (action === 'remove') window[kind].removeItem(key);
      else if (action === 'set') window[kind].setItem(key, value);
    } catch (error) {
      // A blocked storage area must not prevent the normal purchase flow.
    }
    return null;
  }

  function storedIntent(kind) {
    try {
      const value = JSON.parse(storage(kind, 'get', storageKey) || 'null');
      if (value?.code !== rewardCode || !Number.isFinite(value.expiresAt)) return null;
      return value;
    } catch (error) {
      return null;
    }
  }

  const saved = [storedIntent('localStorage'), storedIntent('sessionStorage')].filter(Boolean);
  const params = new URLSearchParams(window.location.search);
  const fromUrl = params.get(rewardParam) === rewardCode;
  const fromLegacy = storage('sessionStorage', 'get', legacySessionKey) === rewardCode;
  let expiresAt = 0;

  if (saved.length) {
    // Navigation preserves a live deadline. An explicit new survey link can
    // restart an expired intent; propagated links always carry their deadline.
    expiresAt = Math.min(...saved.map((value) => value.expiresAt), campaignEndsAt);
    if (expiresAt <= now && fromUrl && !params.has(expiryParam)) {
      expiresAt = Math.min(now + lifetimeMs, campaignEndsAt);
    }
  } else if (fromUrl || fromLegacy) {
    const linkedExpiry = params.has(expiryParam) ? Number(params.get(expiryParam)) : now + lifetimeMs;
    if (Number.isFinite(linkedExpiry) && linkedExpiry > now) {
      expiresAt = Math.min(linkedExpiry, now + lifetimeMs, campaignEndsAt);
    }
  }

  if (expiresAt) {
    const payload = JSON.stringify({ code: rewardCode, expiresAt });
    storage('localStorage', 'set', storageKey, payload);
    storage('sessionStorage', 'set', storageKey, payload);
  }
  // The old unbounded flag is migrated once; it must not bypass the deadline.
  storage('sessionStorage', 'remove', legacySessionKey);

  const getCode = () => Date.now() < expiresAt && Date.now() < campaignEndsAt ? rewardCode : null;
  const clear = () => {
    expiresAt = 0;
    for (const kind of ['localStorage', 'sessionStorage']) storage(kind, 'remove', storageKey);
    storage('sessionStorage', 'remove', legacySessionKey);
    const url = new URL(window.location.href);
    url.searchParams.delete(rewardParam);
    url.searchParams.delete(expiryParam);
    window.history.replaceState(window.history.state, '', url);
    renderIntent();
  };
  // Clearing the reminder never removes an already applied Shopify discount.
  window.MMSurveyReward = { getCode, clear };
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-mm-survey-reward-clear]')) clear();
  });

  function preserveIntentOnLinks(active) {
    document.querySelectorAll('a[href]').forEach((link) => {
      let url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      if (!/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?(?:products\/|collections\/|cart(?:\/|$))/.test(url.pathname)) return;
      if (active) {
        url.searchParams.set(rewardParam, rewardCode);
        // Preserve the same deadline even when browser storage is unavailable.
        url.searchParams.set(expiryParam, String(expiresAt));
      } else if (url.searchParams.get(rewardParam) === rewardCode) {
        url.searchParams.delete(rewardParam);
        url.searchParams.delete(expiryParam);
      } else {
        return;
      }
      link.href = url.toString();
    });
  }

  function renderIntent() {
    const active = Boolean(getCode());
    document.documentElement.classList.toggle('mm-survey-reward-pending', active);
    document.querySelectorAll('[data-mm-survey-reward-banner]').forEach((banner) => {
      banner.hidden = !active;
    });
    document.querySelectorAll('[data-mm-survey-reward-journey]').forEach((banner) => {
      banner.hidden = !active || banner.dataset.mmPageType === 'index';
    });
    preserveIntentOnLinks(active);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderIntent, { once: true });
  else renderIntent();
  document.addEventListener('shopify:section:load', renderIntent);
  document.addEventListener('visibilitychange', renderIntent);
  window.addEventListener('pageshow', renderIntent);
  if (expiresAt > now) window.setTimeout(renderIntent, Math.min(expiresAt - now + 1, lifetimeMs + 1));
})();
